import { Component, Inject } from '@angular/core';

import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IconComponent } from '@app/shared/components/icon/icon';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [IconComponent, MatDialogModule],
  templateUrl: './confirm-dialog.html',
  styleUrls: ['./confirm-dialog.scss'],
})
export class ConfirmDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      iconName: string;
      message: string[];
      primaryText: string;
      secondaryText: string;
    },
  ) {}
}
